import { IGender } from "../Interfaces/IGender";

export const genderArray: IGender[] = [
  { idGender: 1, Gender: "männlich" },
  { idGender: 2, Gender: "weiblich" },
  { idGender: 3, Gender: "divers" },
  { idGender: 4, Gender: "keine Angabe" },
];
